import { IRankingDiscipline } from '@studyportals/domain-client';

export class Organisation {
	public constructor(
		public readonly id: string,
		public readonly name: string,
		public readonly url: string,

		public readonly hasDeliveryMethodOnline: boolean,
		public readonly hasDeliveryMethodOnCampus: boolean,
		public readonly hasDeliveryMethodBlended: boolean,

		public readonly locationCityName: string | null,
		public readonly locationCityRelativeLinkOfDetailPage: string | null,
		public readonly locationCountryIsoCode: string | null,
		public readonly locationCountryRelativeLinkOfDetailPage: string | null,

		public readonly mayShowLogoSquare: boolean,
		public readonly logoSquareCdn: string | null,

		public readonly summary: string | null,

		public readonly isPremium: boolean,

		public readonly venuesCount: number,

		public readonly numberOfProgrammes: number | null,
		public readonly numberOfScholarships: number | null,

		public readonly isForProfitFunding: boolean | null,
		public readonly isNonProfitFunding: boolean | null,
		public readonly isPublicFunding: boolean | null,

		public readonly globalMetaRankingPosition: number | null,
		public readonly globalPositionPercentage: string | null,
		public readonly metaRankingPositionsPerDiscipline: IRankingDiscipline[] | null
	) { }
}
